import { Link } from 'react-router-dom';
import { posts } from './posts';
import './Blog.css';
import logo from '../assets/reel-easy-logo.png';

export default function BlogList() {
  return (
    <div className="blog-page">
      <header className="blog-header">
        <div className="container">
          <Link to="/">
            <img src={logo} alt="Reel Easy Retreat" className="blog-logo" />
          </Link>
          <h1>From the Retreat</h1>
          <p className="blog-header-sub">Local tips, area guides, and lake life from Reel Easy Retreat on Lake Lanier</p>
        </div>
      </header>

      <main className="blog-main">
        <div className="container">
          <div className="post-list">
            {posts.map(post => (
              <article key={post.slug} className="post-card">
                <Link to={`/blog/${post.slug}`} className="post-card-link">
                  <time className="post-date">{new Date(post.date).toLocaleDateString('en-US', { year: 'numeric', month: 'long', day: 'numeric' })}</time>
                  <h2 className="post-title">{post.title}</h2>
                  <p className="post-excerpt">{post.excerpt}</p>
                  <span className="post-read-more">Read more →</span>
                </Link>
              </article>
            ))}
          </div>
        </div>
      </main>

      <footer className="blog-footer">
        <div className="container">
          <Link to="/" className="back-home">← Back to Reel Easy Retreat</Link>
        </div>
      </footer>
    </div>
  );
}
